export default __webpack_public_path__ + "static/media/icon-pinned.47a6dc44.svg";